function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 13C17 13 15 15.343 15 17V30C15 31.9422 16.3849 33.5572 18.2207 33.9199L16.6816 37H19L20.5 34H29.5L31 37H33.3184L31.7793 33.9199C33.6151 33.5572 35 31.9422 35 30V17C35 15.343 33 13 25 13ZM18 17H23C23.552 17 24 17.448 24 18V22C24 22.552 23.552 23 23 23H18C17.448 23 17 22.552 17 22V18C17 17.448 17.448 17 18 17ZM27 17H32C32.552 17 33 17.448 33 18V22C33 22.552 32.552 23 32 23H27C26.448 23 26 22.552 26 22V18C26 17.448 26.448 17 27 17ZM19.5 28C20.328 28 21 28.672 21 29.5C21 30.328 20.328 31 19.5 31C18.672 31 18 30.328 18 29.5C18 28.672 18.672 28 19.5 28ZM30.5 28C31.328 28 32 28.672 32 29.5C32 30.328 31.328 31 30.5 31C29.672 31 29 30.328 29 29.5C29 28.672 29.672 28 30.5 28Z"
});

function SvgIcF06B40Ef265944Ab92617386Ce96D336(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcF06B40Ef265944Ab92617386Ce96D336);
export default ForwardRef;